import { render, staticRenderFns } from "./contractPhase.vue?vue&type=template&id=24538aac&scoped=true"
import script from "./contractPhase.vue?vue&type=script&lang=js"
export * from "./contractPhase.vue?vue&type=script&lang=js"
import style0 from "./contractPhase.vue?vue&type=style&index=0&id=24538aac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24538aac",
  null
  
)

export default component.exports